import styled from "styled-components";
import CompanyUserList from "./component";

export default styled(CompanyUserList)``;
